import TableAHSF from "../../../Components/TableAHSF";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { encryptToken } from "../../../Services/Encryption/EncryptionParams";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import PopupAHSF from "../../../Components/PopupAHSF";

const SubObjectivesCheckBox = (props) => {
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks
  );
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "subObjectivesName",
      ShowStatus: true,
      NmaeColumn: "الهدف",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  console.log(arrayDataCheckBoks, "ssssssdwdwdddd");

  const RequestsManagerBtns = [];

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"taskId"}
        valueButtonAction={"taskId"}
        URL={`api/SubObjectives/GetListSubObjectives`}
        UrlBody={{
          reportId: props.reportId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الاهداف الفرعية"}
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        uniqeKeyName={"subObjectivesId"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={true}
        uniqeKeyNameRedux={"SubObjectives"}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={<></>}
      />
    </>
  );
};
export default SubObjectivesCheckBox;
